module.exports = __webpack_public_path__ + "static/img/a-universe-of-endless-possibilities.c780a66a.jpg";